<template>
  <div class="content">
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-12">
            <!-- <div class="card-header">
              <form class="form-inline" @submit.prevent="fetch">
                <select-input
                  label="name"
                  v-model="form.account_id"
                  :reduce="(field) => field.id"
                  :options="customers"
                  :clearable="true"
                  :placeholder="$t('generic-str.customer')"
                  :style="'minWidth: 120px;'"
                  :class="'mr-sm-2'"
                />
                <date-range-picker
                  class="form-control mr-sm-2"
                  value
                  :options="options"
                  @change="changeDate"
                />
                <button type="submit" class="btn btn-primary">{{$t('generic-str.filter')}}</button>
              </form>
            </div> -->
            <div v-if="filtered" class="card-body p-0">
              <div v-if="fetched" class="table-responsive">
                <table
                  v-if="Object.keys(insights).length"
                  class="table table-striped"
                >
                  <thead>
                    <tr>
                      <th scope="col">{{$tc('generic-str.acc', 1)}}</th>
                      <th scope="col">{{$tc('generic-str.status.lbl-delivered', 2)}}</th>
                      <th scope="col">{{$tc('app.accepted', 2)}}</th>
                      <th scope="col">{{$tc('generic-str.status.lbl-blocked', 2)}}</th>
                      <th scope="col">{{$tc('generic-str.status.lbl-dropped', 2)}}</th>
                      <th scope="col">{{$tc('generic-str.status.lbl-bounced', 2)}}</th>
                      <th scope="col">{{$tc('generic-str.sent-a', 2)}}</th>
                      <th scope="col">{{$tc('generic-str.status.lbl-open', 2)}}</th>
                      <th scope="col">{{$tc('app.failed', 2)}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><b>TOTAL</b></td>
                      <td>{{ total.delivered }}</td>
                      <td>{{ total.accepted }}</td>
                      <td>{{ total.blocked }}</td>
                      <td>{{ total.dropped }}</td>
                      <td>{{ total.bounced }}</td>
                      <td>{{ total.sent }}</td>
                      <td>{{ total.opened }}</td>
                      <td>{{ total.failed }}</td>
                    </tr>
                    <tr v-for="(insight, id) in insights" :key="id">
                      <td>{{ insight.account_name }}</td>
                      <td>{{ insight.delivered ? insight.delivered : 0 }}</td>
                      <td>{{ insight.accepted ? insight.accepted : 0 }}</td>
                      <td>{{ insight.blocked ? insight.blocked : 0 }}</td>
                      <td>
                        {{ insight.dropped ? insight.dropped : 0 }}
                      </td>
                      <td>{{ insight.bounced ? insight.bounced : 0 }}</td>
                      <td>{{ insight.sent ? insight.sent : 0 }}</td>
                      <td>{{ insight.opened ? insight.opened : 0 }}</td>
                      <td>{{ insight.failed ? insight.failed : 0 }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="text-center table-placeholder">
                  <i class="fas fa-envelope font-size-80"></i>
                  <h5 class="card-title m-t-20">{{$t('sms-report-component.none')}}</h5>
                </div>
              </div>
              <div v-else class="static qt-block-ui" style="padding: 120px" />
            </div>
            <div v-else class="text-center table-placeholder">
              <i class="fas fa-envelope font-size-80"></i>
              <h5 class="card-title m-t-20">{{$t('sms-report-component.none')}}</h5>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment';
import CustomerService from '@/services/customer.service';
import EmailService from '@/services/admin/email.service';
import SelectInput from '@/components/SelectInput.vue';

export default {
  name: 'EmailInsights',
  /* components: {
    SelectInput,
  }, */
  props: ['date-gte', 'date-lte', 'accounts'],
  data() {
    return {
      fetched: false,
      options: {
        timePicker: false,
        autoApply: true,
        className: 'form-control',
        maxSpan: {
          days: 31,
        },
        locale: {
          format: 'DD/MM/YYYY',
          daysOfWeek: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Otu',
            'Nov',
            'Dez',
          ],
        },
      },
      filtered: false,
      customers: [],
      insights: [],
      total: {},
      beginDate: '',
      endDate: '',
      form: {
        account_id: {
          in: [],
        },
        created_at: {
          gte: '',
          lte: '',
        },
      },
    };
  },
  watch: {
    dateGte: 'fetch',
    dateLte: 'fetch',
  },
  created() {
    this.fetchCustomers();
    this.fetch();
  },
  methods: {
    fetchCustomers() {
      CustomerService.getCustomers().then(
        (customers) => {
          this.customers = customers;
          this.customers.push(this.$store.state.account);
        },
        (error) => {
          this.content = error;
        },
      );
    },
    fetch(page = 1) {
      this.form.account_id.in = this.accounts;
      this.form.created_at.gte = this.dateGte;
      this.form.created_at.lte = this.dateLte;
      console.log('form completo ==>', this.form);
      if (!this.filtered) this.filtered = true;
      this.fetched = false;
      EmailService.getInsights(this.form).then(
        (insights) => {
          this.total = {
            accepted: 0,
            sent: 0,
            delivered: 0,
            dropped: 0,
            failed: 0,
            blocked: 0,
            bounced: 0,
            opened: 0,
          };
          this.insights = insights;
          Object.values(insights).forEach((insight, i) => {
            insight.tariffed = 0;
            Object.entries(insight).forEach((array) => {
              if (array[0] !== 'account_name') {
                this.total[array[0]] += array[1];
                if (array[0] !== 'failed') {
                  insight.tariffed += array[1];
                }
              }
            });
            this.total.tariffed += insight.tariffed;
          });
          this.fetched = true;
        },
        (error) => {
          this.content = error;
        },
      );
    },
    changeInsight() {
      /* if (date) {
        this.beginDate = moment(date[0], 'DD/MM/YYYY').format(
          'YYYY-MM-DD 00:00:00',
        );
        this.endDate = moment(date[1], 'DD/MM/YYYY').format(
          'YYYY-MM-DD 23:59:59',
        );
      } else {
        this.beginDate = moment().format('YYYY-MM-DD 00:00:00');
        this.endDate = moment().format('YYYY-MM-DD 23:59:59');
      }
       this.form.created_at.gte = this.beginDate;
       this.form.created_at.lte = this.endDate;
       */
    },
    addFilter() {
      this.filters.push({
        field: '',
        values: null,
      });
    },
    removeFilter(n) {
      this.filters.splice(n, 1);
      // this.fetchAll();
    },
  },
};
</script>
